<form #form [formGroup]="formGroup" *ngIf="nameOnly">
  <bit-form-field>
    <bit-label>{{ "organizationName" | vfo1I18n: "vaultName" }}</bit-label>
    <input bitInput type="text" formControlName="name" />
  </bit-form-field>
</form>
<form #form [formGroup]="formGroup" *ngIf="!nameOnly">
  @if (!vfo1Enabled()) {
    <h2>{{ "generalInformation" | i18n }}</h2>
  }
  @if (createOrganization) {
    @if (vfo1Enabled()) {
      <bit-form-field>
        <bit-label>{{ "organizationName" | vfo1I18n: "vaultName" }}</bit-label>
        <input bitInput type="text" formControlName="name" />
      </bit-form-field>
      <bit-form-field>
        <bit-label>{{ "billingEmail" | i18n }}</bit-label>
        <input bitInput type="email" formControlName="billingEmail" />
      </bit-form-field>
      @if (isProvider) {
        <bit-form-field>
          <bit-label>{{ "clientOwnerEmail" | i18n }}</bit-label>
          <input bitInput type="email" formControlName="clientOwnerEmail" />
        </bit-form-field>
      }
    } @else {
      <div class="tw-flex tw-w-full tw-space-x-4">
        <bit-form-field class="tw-w-1/2">
          <bit-label>{{ "organizationName" | vfo1I18n: "vaultName" }}</bit-label>
          <input bitInput type="text" formControlName="name" />
        </bit-form-field>
        <bit-form-field class="tw-w-1/2">
          <bit-label>{{ "billingEmail" | i18n }}</bit-label>
          <input bitInput type="email" formControlName="billingEmail" />
        </bit-form-field>
        @if (isProvider) {
          <bit-form-field class="tw-w-1/2">
            <bit-label>{{ "clientOwnerEmail" | i18n }}</bit-label>
            <input bitInput type="email" formControlName="clientOwnerEmail" />
          </bit-form-field>
        }
      </div>
    }
  }
</form>
